import { Box, Stack, Typography } from "@mui/material";
import { splitPenaltyTextForTooltip } from "@utils/compliancePenaltyTooltipFormat";

type Props = { text: string };

const bodySx = {
  fontSize: "13px",
  lineHeight: 1.55,
  color: "#7a1f24",
  fontFamily: "Rethink Sans, sans-serif",
  whiteSpace: "normal",
  wordBreak: "break-word",
} as const;

export function CompliancePenaltyTooltipTitle({ text }: Props) {
  const blocks = splitPenaltyTextForTooltip(text);
  if (blocks.length === 0) return null;

  if (blocks.length === 1) {
    return (
      <Typography component="div" sx={{ ...bodySx, fontWeight: 400 }}>
        ⚠️ {blocks[0]}
      </Typography>
    );
  }

  return (
    <Stack
      component="div"
      spacing={1.2}
      sx={{ maxWidth: "min(560px, calc(100vw - 48px))" }}
    >
      <Typography component="div" sx={{ ...bodySx, fontWeight: 500 }}>
        ⚠️ {blocks[0]}
      </Typography>
      {blocks.slice(1).map((block, i) => (
        <Box
          key={i}
          sx={{
            borderLeft: "3px solid #d4a59a",
            pl: 1.25,
            ml: 0.25,
          }}
        >
          <Typography component="div" sx={{ ...bodySx, fontWeight: 400 }}>
            {block}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
}
